<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue